import separateColorAndOpacity from "utils/separateColorAndOpacity";

function __paintShapeByGeoJsonOnMap__(
  map: any,
  draw: any,
  sourceId: any,
  layerId: any,
  geoJson: any,
  defaultColor: any,
  defaultBorderColor: any,
  layerOpacity: number | null = null
) {
  if (!map || !sourceId || !layerId || !geoJson) {
    return;
  }

  // add GeoJSON source
  map.addSource(sourceId, {
    type: "geojson",
    data: geoJson,
  });

  // detect if there are any LineString/MultiLineString features
  const isGeoJsonHasLineString =
    Array.isArray(geoJson.features) &&
    geoJson.features.some(
      (f: any) =>
        f.geometry.type === "LineString" ||
        f.geometry.type === "MultiLineString"
    );

  // extract color + default opacity from the provided colors
  const { color, opacity } = separateColorAndOpacity(defaultColor);
  const { color: borderColor, opacity: borderOpacity } =
    separateColorAndOpacity(defaultBorderColor);

  // choose user‐provided layerOpacity if set, otherwise the default opacity
  const paintOpacity =
    layerOpacity != null /* catches null OR undefined */
      ? layerOpacity
      : opacity;

  // add the main fill or line layer
  map.addLayer({
    id: layerId,
    type: isGeoJsonHasLineString ? "line" : "fill",
    source: sourceId,
    layout: {},
    paint: {
      // use line-color vs fill-color appropriately
      [isGeoJsonHasLineString ? "line-color" : "fill-color"]: color,
      // use line-opacity vs fill-opacity with fallback
      [isGeoJsonHasLineString ? "line-opacity" : "fill-opacity"]: paintOpacity,
    },
  });

  // if it's a fill polygon, also draw its border
  if (!isGeoJsonHasLineString) {
    map.addLayer({
      id: `${layerId}-border`,
      type: "line",
      source: sourceId,
      layout: {},
      paint: {
        "line-color": borderColor || "#000000",
        "line-width": 1,
        "line-opacity": borderOpacity,
      },
    });
  }
}

export { __paintShapeByGeoJsonOnMap__ };
